import { Component, input, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs';
import { TranslocoDirective } from '@jsverse/transloco';
import { ParametersComponent } from './parameters/parameters.component';
import { TenantUnitReferencesMasterComponent } from './billing-instances-master/tenant-unit-references-master.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Icons } from '../../../../util/Icons';

@Component({
	selector: 'vex-tenantunit',
	imports: [MatTab, MatTabGroup, TranslocoDirective, MatTabContent, ParametersComponent, TenantUnitReferencesMasterComponent, MatIcon, MatTooltip],
	templateUrl: './tenantunit.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './tenantunit.component.scss',
})
export class TenantunitComponent {
	icons = inject(Icons);

	billingId = input<string>('');
}
